import {createDropdown, createItem} from "../../shared-components/common/utils/menu/menu"
import {Page} from "../page/pages"
import {PagesArchitecture} from "../page/pagesArchitecture"

/**
 * Return the menu
 * @param actualPage page where the user is
 * @param navigate    navigate function for navigation
 * @param features   enabled application features
 */
export const menuContent = (actualPage, navigate, features, eattestationUrl) => [
    createDropdown("MISSIONS PROPOSEES", true, [
        createItem(actualPage, navigate, features, Page.WAITING_REQUESTS, PagesArchitecture),
        createItem(actualPage, navigate, features, Page.REQUESTS_HISTORY, PagesArchitecture),
    ]),

    createDropdown("MISSIONS CONFIEES", true, [
        createItem(actualPage, navigate, features, Page.NEW_MISSION_INPUT_INIT, PagesArchitecture),
        createItem(actualPage, navigate, features, Page.CURRENT_MISSIONS, PagesArchitecture),
        createItem(actualPage, navigate, features, Page.MISSIONS_HISTORY, PagesArchitecture),
    ]),

    createItem(actualPage, navigate, features, Page.INVOICES, PagesArchitecture),
    createItem(actualPage, navigate, features, Page.PRICE_LIST, PagesArchitecture),
    createItem(actualPage, navigate, features, Page.LOGIN, PagesArchitecture),
    createItem(actualPage, navigate, features, Page.EATTESTATIONS, PagesArchitecture, undefined, () =>
        window.open(eattestationUrl),
    ),
]
